import React, { useState } from 'react';
import clsx from 'clsx';
import * as PropTypes from 'prop-types';

import { CATEGORY_TYPES } from '$app-web/components/chat/constants';
import Loading from '$app-web/components/loading';

import { useIsCreatingARoom, useIsRoomsSearchRemote } from '../state/chat-client.state';
import Categories from './categories';
import RoomsList from './rooms-list';
import SearchBar from './search-bar';
import classes from './styles.module.scss';

const Sidebar = (props) => {
    const { category, categoryOnChange, currentRoomId, roomOnClick } = props;

    const [shouldShowArchiveds, setShouldShowArchiveds] = useState(false);

    const isRoomsSearchRemote = useIsRoomsSearchRemote();
    const isCreatingARoom = useIsCreatingARoom();

    return (
        <div className="flex column nowrap">
            <div className="item">
                <SearchBar onChangeShouldShowArchiveds={setShouldShowArchiveds} showArchiveds={shouldShowArchiveds} />
            </div>
            {!isRoomsSearchRemote && (
                <div className="item">
                    <Categories currentCategory={category} onChange={categoryOnChange} />
                </div>
            )}
            <div className={clsx('item', classes.roomsList)}>
                <RoomsList
                    category={category}
                    currentRoomId={currentRoomId}
                    roomOnClick={roomOnClick}
                    showArchiveds={shouldShowArchiveds}
                />
            </div>
            <Loading variant="parent-overlay" loading={isCreatingARoom} />
        </div>
    );
};

Sidebar.defaultProps = {
    currentRoomId: undefined,
};

Sidebar.propTypes = {
    category: PropTypes.oneOf(Object.values(CATEGORY_TYPES)).isRequired,
    categoryOnChange: PropTypes.func.isRequired,
    currentRoomId: PropTypes.string,
    roomOnClick: PropTypes.func.isRequired,
};

export default Sidebar;
